import React from 'react';

import ProjectSubmissionTable from './utils/table';

import { ResetFilterIcon } from '../../icons/enrolledUserIcons';

const RefreshCounterContext = React.createContext();

function ProjectSubmissions() {
  const [goalType, setGoalType] = React.useState('dataScience');
  const [refreshCounter, setRefreshCounter] = React.useState(0);
  const [isApplyDefaultFilter, setIsApplyDefaultFilter] = React.useState(false);

  function resetFilter() {
    setIsApplyDefaultFilter(true);
  }

  return (
    <div className='flex flex-col gap-4'>
      <h1 className='text-2xl font-semibold'>Project Submissions</h1>
      <div className='p-4 flex gap-8 bg-white rounded-md text-sm'>
        <h2
          className={`${
            goalType === 'dataScience'
              ? 'text-red-c3 font-semibold'
              : 'text-gray-c4'
          } cursor-pointer`}
          onClick={() => setGoalType('dataScience')}
        >
          Data Science
        </h2>
        <h2
          className={`${
            goalType === 'web3' ? 'text-red-c3 font-semibold' : 'text-gray-c4'
          } cursor-pointer`}
          onClick={() => setGoalType('web3')}
        >
          Web 3.0
        </h2>
        <h2
          className={`${
            goalType === 'ugDiplomaCS' ? 'text-red-c3 font-semibold' : 'text-gray-c4'
          } cursor-pointer`}
          onClick={() => setGoalType('ugDiplomaCS')}
        >
          Ug Diploma CS
        </h2>
      </div>

      {/* filter */}
      <div className='flex gap-8 items-center'>
        <div
          className='flex gap-2 items-center cursor-pointer'
          onClick={resetFilter}
        >
          <ResetFilterIcon />
          <p className='text-red-700 font-semibold text-sm'>Reset Filters</p>
        </div>
        <div className='flex gap-2 items-center cursor-pointer'>
          <p
            className='text-red-700 ml-1 p-2 font-semibold text-sm'
            onClick={() => {
              setRefreshCounter((counter) => counter + 1);
            }}
          >
            Refresh
          </p>
        </div>
      </div>

      {/* Table */}
      <div>
        <RefreshCounterContext.Provider value={setRefreshCounter}>
          <ProjectSubmissionTable
            isApplyDefaultFilter={isApplyDefaultFilter}
            setIsApplyDefaultFilter={setIsApplyDefaultFilter}
            goalType={goalType}
            refreshCounter={refreshCounter}
          />
        </RefreshCounterContext.Provider>
      </div>
    </div>
  );
}

export default ProjectSubmissions;
export { RefreshCounterContext };
